import React from "react";
import "./services.css";

const servicesData = [
  {
    title: "Enterprise Web Applications",
    description:
      "Build the perfect application to keep your business moving forward.",
    imgUrl: "/assets/img/Services/webapps.webp",
  },
  {
    title: "Mobile App Development",
    description:
      "Push your Android or/and iOS app to market at once with Native & Hybrid Technologies",
    imgUrl: "/assets/img/Services/mobileappdev.webp",
  },
  {
    title: "Cloud & DevOps",
    description:
      "Environment configuration, CI/CD, and consultation to future-proof your software.",
    imgUrl: "/assets/img/Services/cloudanddevops.webp",
  },
  {
    title: "IoT & Embedded Development",
    description:
      "Our Special team masters ins and outs of 5TI - Things that talk to the internet.",
    imgUrl: "/assets/img/Services/iot.webp",
  },
  {
    title: "SEO & Digital Marketing",
    description:
      "Our innovative strategies help you measure and improve your online results.",
    imgUrl: "/assets/img/Services/seoandmarketing.webp",
  },
  {
    title: "Bussiness Development Tools",
    description:
      "Custom made tools and Apps to help you enhance your bussiness processes.",
    imgUrl: "/assets/img/Services/bdservice.webp",
  },
  {
    title: "ChatBot Development ",
    description:
      "Highly sophisticated and intelligent chatbot development for all major platforms.",
    imgUrl: "/assets/img/Services/chatAi.webp",
  },
  {
    title: "AR/VR Experiences",
    description:
      "Immerse yourself in AR / VR development solutions and lead your company to success.",
    imgUrl: "/assets/img/Services/arvrexp.webp",
  },
];

const Services = () => (
  <section className="scrobits__services section__padding" id={"services"}>
    <div className="scrobits__services-heading">
      <h1 className="gradient__text">Services</h1>
      <div />
      <p>
        Our dedicated team will deliver a quality solution; from early stages to
        successful product. We use most reliable, scalable, responsive and
        secure technology stack; and design the finest UX & UI.
      </p>
    </div>
    <div className="scrobits__services-container">
      {servicesData.map((item, index) => (
        <Service data={item} key={index} />
      ))}
    </div>
  </section>
);

export default Services;

function Service({ data }) {
  const { title, description, imgUrl } = data;
  return (
    <article
      className="scrobits__service-container"
      data-aos="flip-down"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <span className="scrobits__service-icon">
        <img src={imgUrl || "#"} alt={title} />
      </span>
      <h3 className="scrobits__service-title">{title}</h3>
      <div />
      <p className="scrobits__service-description">{description}</p>
    </article>
  );
}
